class Carousel {
    constructor(element) {
        this.carousel = element;
        this.slides = Array.from(this.carousel.getElementsByClassName('header-carousel-item'));
        this.currentSlide = 0;
        this.slideInterval = null;
        
        // Set initial state
        this.updateSlides();
        
        // Auto play
        this.startAutoPlay();
    }

    updateSlides() {
        this.slides.forEach((slide, index) => {
            if (index === this.currentSlide) {
                slide.style.display = 'block';
                slide.classList.add('active', 'slide-in-right');
                setTimeout(() => {
                    slide.classList.remove('slide-in-right');
                }, 500);
            } else {
                slide.style.display = 'none';
            }
            return;
        });
    }

    nextSlide() {
        this.currentSlide = (this.currentSlide + 1) % this.slides.length;
        this.updateSlides();
    }

    prevSlide() {
        this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
        this.updateSlides();
    }

    startAutoPlay() {
        this.slideInterval = setInterval(() => this.nextSlide(), 7000);
    }

    stopAutoPlay() {
        if (this.slideInterval) {
            clearInterval(this.slideInterval);
        }
    }
}

export default Carousel;